var _defs, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2000 2000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1e266d;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 2000,
    height: 2000,
    rx: 251
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_3",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1171.15,964.26H794.45s8.86-94.09,43-141.76,41.35-56.11,81.85-78c.23-.12.45-.25.68-.36a115.81,115.81,0,1,1,126.38-.49c2.38.53,3.7.85,3.7.85s62.89,36.7,86.51,92.82S1166,907.72,1171.15,964.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1203.25 961.41 977.06 1017.08 762.35 961.41 1203.25 961.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M982.8,394.46c-182.22,0-329.95,147.72-329.95,329.94s147.73,329.95,329.95,329.95,330-147.72,330-329.95S1165,394.46,982.8,394.46Zm0,593.9c-145.78,0-264-118.18-264-264S837,460.45,982.8,460.45s264,118.17,264,264S1128.58,988.36,982.8,988.36Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1017.87,
    y: 362.23,
    width: 216.55,
    height: 34.9,
    transform: "translate(1908.06 -515.3) rotate(112.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 520.6,
    y: 569.44,
    width: 224.25,
    height: 34.9,
    transform: "translate(272.91 -197.53) rotate(22.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 723.33,
    y: 1060,
    width: 227.26,
    height: 34.9,
    transform: "translate(2152.76 716.77) rotate(112.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1216.78,
    y: 857.84,
    width: 223.66,
    height: 34.9,
    transform: "translate(436.35 -441.98) rotate(22.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 520.54,
    y: 857.08,
    width: 225.72,
    height: 34.9,
    transform: "translate(1553.14 1440.28) rotate(157.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1220.58,
    y: 568.15,
    width: 220.09,
    height: 34.9,
    transform: "translate(2784.05 617.7) rotate(157.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 726,
    y: 363.14,
    width: 219.81,
    height: 34.9,
    transform: "translate(867.82 -537.32) rotate(67.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1011.14,
    y: 1061.03,
    width: 225.76,
    height: 34.9,
    transform: "translate(1690.55 -372.59) rotate(67.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M509.22,470.1a58.55,58.55,0,1,0,31.46,76.42A58.43,58.43,0,0,0,509.22,470.1Zm-40.35,97.36a46.84,46.84,0,1,1,61-25.41A46.76,46.76,0,0,1,468.87,567.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1208.89,180a58.55,58.55,0,1,0,31.46,76.42A58.44,58.44,0,0,0,1208.89,180Zm-40.35,97.36a46.84,46.84,0,1,1,61-25.41A46.76,46.76,0,0,1,1168.54,277.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1499.05,880.32a58.55,58.55,0,1,0,31.46,76.42A58.44,58.44,0,0,0,1499.05,880.32Zm-40.35,97.36a46.84,46.84,0,1,1,61-25.41A46.74,46.74,0,0,1,1458.7,977.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M798.63,1169.55A58.55,58.55,0,1,0,830.09,1246,58.43,58.43,0,0,0,798.63,1169.55Zm-40.35,97.36a46.84,46.84,0,1,1,61-25.41A46.76,46.76,0,0,1,758.28,1266.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M799.12,179.49a58.55,58.55,0,1,0,31.46,76.41A58.43,58.43,0,0,0,799.12,179.49Zm-40.35,97.35a46.84,46.84,0,1,1,61-25.4A46.74,46.74,0,0,1,758.77,276.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1496.83,465.69a58.55,58.55,0,1,0,31.46,76.41A58.43,58.43,0,0,0,1496.83,465.69ZM1456.48,563a46.83,46.83,0,1,1,61-25.4A46.75,46.75,0,0,1,1456.48,563Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1209.09,1170.53a58.55,58.55,0,1,0,31.46,76.42A58.44,58.44,0,0,0,1209.09,1170.53Zm-40.35,97.36a46.84,46.84,0,1,1,61-25.41A46.76,46.76,0,0,1,1168.74,1267.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M509.42,880a58.55,58.55,0,1,0,31.46,76.41A58.43,58.43,0,0,0,509.42,880Zm-40.35,97.35a46.84,46.84,0,1,1,61-25.4A46.75,46.75,0,0,1,469.07,977.31Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 825.5,
    y: 224.49,
    width: 314.56,
    height: 18.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 823.12,
    y: 1215.56,
    width: 314.56,
    height: 18.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 329.96,
    y: 720.02,
    width: 314.56,
    height: 18.13,
    transform: "translate(1216.33 241.84) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1319.25,
    y: 720.02,
    width: 314.56,
    height: 18.13,
    transform: "translate(2205.62 -747.45) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1174.89,
    y: 367.08,
    width: 312.34,
    height: 18.13,
    transform: "translate(655.83 -831.03) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 475.36,
    y: 370.02,
    width: 312.34,
    height: 18.13,
    transform: "translate(1346.13 200.58) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1175.73,
    y: 1070.4,
    width: 312.34,
    height: 18.13,
    transform: "translate(3036.99 900.96) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 475.78,
    y: 1070.4,
    width: 312.34,
    height: 18.13,
    transform: "translate(948.39 -130.69) rotate(45)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_4",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M588.35,1624.56v61.09H310.44V1405.87H385v218.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M629.24,1405.87H842.57c78,0,112.66,29.09,112.66,108.55V1573c0,76.47-24.62,112.65-102.59,112.65H629.24Zm74.6,218.79H841.07c27.61,0,37.31-18.28,37.31-47.76v-66.3c0-36.19-11.57-43.64-37.68-43.64H703.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1324.38,1687.17h-76.1l-19.62-64.91h-150.5l-19.62,64.91h-76.1l85-279.77h171.84Zm-199.71-218.69-26.55,88.88H1208.7l-26.55-88.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1689.56,1513.37c0,13.48-.74,34.22-2.56,46-7.13,46-30.9,65.35-92.94,65.35H1439.44v60.9h-74.61V1405.88h229.24c55.78,0,83.6,16.64,92.35,61.17C1688.56,1477.9,1689.56,1499.9,1689.56,1513.37Zm-76.84-21a25.33,25.33,0,0,0-25.34-25.33h-148v92.8h148a25.33,25.33,0,0,0,25.34-25.33Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1cb608923bc81683530fd83e35f927d3.svg";
export { ForwardRef as ReactComponent };